import { call, METHODS } from '../http-client';

const ROUTE_PREFIX = 'help';


export const getToken = async () => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, 'token');
    } catch (e) {
    }
}
